const API_PREFIX = 'ccmei'

export default {
  paged: (page, pageSize) => `${API_PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`,
  url: id => `${API_PREFIX}/${id}/url`,
  observacoes: id => `${API_PREFIX}/${id}/observacao`,
  removerObservacao: id => `${API_PREFIX}/observacao/${id}/remover`,
  salvarObservacao: `${API_PREFIX}/observacao/salvar`,
  baixaLotes: nomeArquivo => `${API_PREFIX}/baixa-lotes?nomeArquivo=${nomeArquivo}`,
  baixaExcel: tipo => `${API_PREFIX}/${tipo}/baixa-excel`,
  notifica: id => `${API_PREFIX}/${id}/notifica`,
  verificarEmail: `${API_PREFIX}/verificar-email`,
  enviarEmail: nomeArquivo => `${API_PREFIX}/enviar-email?nomeArquivo=${encodeURIComponent(nomeArquivo || '')}`,
  urlWhatsapp: id => `${API_PREFIX}/${id}/url`,
  notificaHistorico: (emailEmpresa, emailCc, nomeEmpresa, mensagemAdicional, definirEmailPadrao) => `${API_PREFIX}/notifica-historico?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional || '')}&definirEmailPadrao=${definirEmailPadrao}`,
}
